import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { INgPureDropdownOption } from './pure-dropdown.interface';
import { NgAbstractInputComponent } from '../shared/inputs.abstract';


@Component({
    selector: 'ng-pure-dropdown',
    templateUrl: './pure-dropdown.component.html',
    styleUrls: ['./pure-dropdown.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgPureDropdownComponent,
            multi: true
        }],
    standalone: false
})
export class NgPureDropdownComponent extends NgAbstractInputComponent<string> implements ControlValueAccessor {

	@ViewChild('dropdownButton', { static: true }) button!: ElementRef<HTMLButtonElement>;
	@ViewChild('dropdownMenu', { static: true }) menu!: ElementRef<HTMLDivElement>;

	//** Input decorators */
	@Input() buttonClass	: string = 'flying-dropdown-button';
	@Input() menuClass		: string = 'flying-dropdown-menu py-2';
	@Input() menuOptionClass: string = 'flying-dropdown-item';
	@Input() options		: INgPureDropdownOption[] = [];

	//** ControlValueAccessor implementation */
	override value: string = '';

	//** Helper Variables */
	hasOpen: boolean = false;

	constructor(
		private elementRef: ElementRef
	) {
		super('custom-dropdown');
	}

	toggle(): void {
		this.hasOpen = !this.hasOpen;
		this.setButtonStyle();
		this.menu.nativeElement.style.setProperty('width', `${this.button.nativeElement.offsetWidth}px`);
	}


	/**------------------------------------------------------
	 * Handle Option Selection & Closing
	 */
	selectOption(option: INgPureDropdownOption): void {
		this.value = option.code;
		this.onChange(this.value);
		this.hasOpen = false;
		this.setButtonStyle();
	}

	@HostListener('document:click', ['$event'])
	close(event: MouseEvent): void {
		if (!this.elementRef.nativeElement.contains(event.target)) this.hasOpen = false;
		this.setButtonStyle();
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private setButtonStyle(): void {
		this.button.nativeElement.style.borderBottomRightRadius = this.hasOpen ? '0' : '6px';
		this.button.nativeElement.style.borderBottomLeftRadius = this.hasOpen ? '0' : '6px';
	}
}
